$(function(){
	//下拉选择
	$(".select-box").each(function(){
		var $elm=$(this);
		var optionList=$('.select-con',$elm);
		var showOption=$('.select-title span',$elm);
		var isOpen = false;
		$elm.bind("click", function() {
			if(isOpen == false){
				optionList.show().siblings('.select-box').find('.select-con').hide();
				isOpen = true;
			}else {
				optionList.hide();
				isOpen = false;
			}
			
		});
		$('li',optionList).bind('click',function(){
			var $elm=$(this);
			var op=$elm.text();
			showOption.text(op);
			optionList.hide();
		});
	});
	(function() {
		var isOpen = false,
			$box = $('.select-box');
		$box.each(function() {
			var selector = $(this);
			selector.on('click', '.select-con li', function() {
				var $con = selector.find('.select-title span'),
					$text = $(this).text();
				$con.html($text);
				isOpen = false;
			});
		});
	
	})();
	
	$(window).scroll(function(){
		let _banner=$(".inner-banner");
		if(_banner.length>0){
			var top = _banner.offset().top;
			var scrollTop = $(window).scrollTop();
			if(scrollTop > top){
				$(".header").addClass("active");
			}else{
				$(".header").removeClass("active");
			}
		}
	})
});


//////////////////
// WEBPACK FOOTER
// ./static/js/inner.js
// module id = W7uY
// module chunks = 0